import React from "react";
import Link from "next/link";

import { Action, Category } from "@/constants/events";
import { SUBCATEGORY_LINK_NAMES } from "@/constants/products";
import { useEventTracker } from "@/hooks/useEventTracker";

import Carousel from "@/components/botanic/Carousel";

type Props = {
  categorySlug: string;
  subcategories: string[];
  className?: string;
  headingClassName?: string;
  title: string;
};

const SubcategoryCarousel: React.FC<Props> = ({
  categorySlug,
  subcategories,
  className,
  headingClassName,
  title,
}) => {
  const { publishEvent } = useEventTracker();

  const getSubcatDisplayName = (subcat: string) => {
    return SUBCATEGORY_LINK_NAMES[subcat] || subcat;
  };
  return (
    <Carousel
      className={className}
      title={title}
      cardsPerSlide={10}
      headingClassName={headingClassName}
      mobileCardWidth={80}
    >
      {subcategories.map((subcat, index) => (
        <Coin
          key={`${subcat}-${index}`}
          subcategory={getSubcatDisplayName(subcat)}
          href={`/products/${categorySlug}/${subcat}`}
          onClick={() => {
            publishEvent({
              action: Action.click,
              category: Category.productCategoryCoinFilter,
              label: getSubcatDisplayName(subcat),
            });
          }}
          title={getSubcatDisplayName(subcat)}
        />
      ))}
    </Carousel>
  );
};

const Coin = ({
  onClick,
  href,
  subcategory,
  title,
}: {
  onClick: () => void;
  href: string;
  subcategory: string;
  title: string;
}) => {
  return (
    <Link
      key={subcategory}
      href={href}
      onClick={onClick}
      className="flex border border-grey-44 flex-col items-center justify-center h-[80px] bg-green-20 rounded-[8px] px-md"
      data-testid={`${subcategory}-products-category`}
    >
      <span className="text-xs">{title}</span>
    </Link>
  );
};

export default SubcategoryCarousel;
